// extracted by mini-css-extract-plugin
module.exports = {"icone":"Tarefa_icone__ZKXxX","marcador":"Tarefa_marcador__UsIoB","bloqueada":"Tarefa_bloqueada__1Ti18"};